import { call, takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import type { ResourceActionCreator, ResourceFailureActionCreator } from '../core/resourceStoreTypes';
import * as actions from './housingSelectionActions';
import { transformResponseToHousingSelection } from './housingSelectionTransformers';
import type { HousingSelectionType } from './housingSelectionTypes';

const mkQcsSyncHousingSelectionConfig =
  resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<HousingSelectionType>();

const mkAutocompleteConfig = (
  successAction: ResourceActionCreator<HousingSelectionType>,
  failureAction: ResourceFailureActionCreator,
  payload: string,
) =>
  mkQcsSyncHousingSelectionConfig({
    resourceName: 'realestate',
    resourceBaseUrl: '/realestate/assets/search',
    axiosConfig: {
      params: {
        query: `line1 == "${payload}"`,
      },
    },
    transformResponseToResources: transformResponseToHousingSelection,

    successAction,
    failureAction,
  });

export function* getAutocompleteHousingSelectionActionWatcher() {
  yield takeEvery(
    actions.getAutocompleteHousingSelection.type,
    function* _getObject(createZillowHouseAccountAction: {
      meta: any;
      payload: string;
      type: 'GET_HOUSINGSELECTION_AC';
    }) {
      const getConfig = mkAutocompleteConfig(
        actions.getAutocompleteHousingSelectionSuccess,
        actions.getAutocompleteHousingSelectionFailure,
        createZillowHouseAccountAction.payload,
      );
      yield call(
        resourceSagaUtils.qcsSyncGetResources<HousingSelectionType>,
        getConfig,
        createZillowHouseAccountAction,
      );
    },
  );
}

export default [getAutocompleteHousingSelectionActionWatcher];
